export default "__VITE_ASSET__CWqPq1KP__"